import { createSlice } from "@reduxjs/toolkit";
import { DocumentState } from "@pdfViewer/models";

const initialState: DocumentState = {
  documentName: null,
  documentId: null,
  documentUrl: null,
  documentError: null,
  isOpenDocumentDialog: false,
};

export const pdfViewerSlice = createSlice({
  name: "pdfViewer",
  initialState,
  reducers: {
    resetState: (state) => {
      state.documentName = initialState.documentName;
      state.documentId = initialState.documentId;
      state.documentUrl = initialState.documentUrl;
      state.documentError = initialState.documentError;
      state.isOpenDocumentDialog = initialState.isOpenDocumentDialog;
    },
    openDocumentDialog: (state, action) => {
      state.documentName = action.payload.documentName;
      state.documentId = action.payload.documentId;
      state.documentUrl = action.payload.documentUrl;
      state.documentError = null;
      state.isOpenDocumentDialog = true;
    },
    setDocumentDialogUrl: (state, action) => {
      const { documentId, documentUrl } = action.payload;

      if (!state.isOpenDocumentDialog || state.documentId !== documentId) {
        return;
      }

      state.documentUrl = documentUrl;
      state.documentError = null;
    },
    setDocumentDialogError: (state, action) => {
      const { documentId, error } = action.payload;

      if (!state.isOpenDocumentDialog || state.documentId !== documentId) {
        return;
      }

      state.documentError = error;
    },
    closeDocumentDialog: (state) => {
      state.isOpenDocumentDialog = false;
    },
  },
});
export const { resetState, openDocumentDialog, setDocumentDialogUrl, setDocumentDialogError, closeDocumentDialog } =
  pdfViewerSlice.actions;
export default pdfViewerSlice.reducer;
